import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { TextField, Typography, MenuItem, Button } from "@mui/material";
import { pad } from "../../../functions/default";
import apiRequest from '../../../functions/api';
import { DateTextField } from '../../lib';
import umlauteErsetzen from "../functions/umlauteErsetzen";
const UploadComponent = ( props ) => {
  const { t } = useTranslation();
  const { client, accessToken, ordner, register, program,setShowModal,auswahlRegister,auswahlOrdner,setIsLoading,showSuccessMessage } = props;
  const [selectedFile, setSelectedFile] = useState(null);//Variable für Datei download  
  const [selectedOrdner, setSelectedOrdner] = useState(auswahlOrdner)
  const [selectedRegister, setSelectedRegister] = useState(auswahlRegister?auswahlRegister:"" )
  const [dateiName, setDateiName] = useState("")
  const [keyWords, setKeyWords] = useState("")
  const [ablageDatum, setAblageDatum] = useState(new Date().getFullYear().toString() + '-' + pad(new Date().getMonth() + 1, 2) + '-' + pad(new Date().getDate(), 2));
  const [step, setStep] = useState(1)
  // console.log(convertToRaw(editorState.getCurrentContent()));

  useEffect(() => {
  }, []);
  const onChangeHandler = (event) => {
    // setSelectedFile(event.target.files);
    console.log(event.target.files)
    setSelectedFile(event.target.files);
    let name=""
    
    
    setDateiName(event.target.files[0].name.substr(0, event.target.files[0].name.indexOf(".")))
    // setShowModal(true)
    // funktionen(payload)
  }
  const uploadDocument = () => {
    let name=""
    const data = new FormData();
    console.log(selectedFile)
       setIsLoading(true)
    for (let index = 0; index < selectedFile.length; index++) {
      data.append('file', selectedFile[index]);
    }
    name=umlauteErsetzen(dateiName)
    console.log(name)
    
   const payload = {
       "beschreibungsArt": "DMS",
       "name":name,
        "ablageDatum":ablageDatum.replace(/-/g,""),
       "register":selectedRegister,
       "keyWords":keyWords,
     
   }
   console.log(payload)
  data.append('payload', JSON.stringify(payload));

   const headers = {
      "Authorization": "Bearer " + accessToken,
      "Mandant": client, // this.props.client,
       "program": program,
       "Statement": "DATEI_IN_DMS_ABLEGEN",
   }
   apiRequest('POST', 'upload', data, headers, saveCB);

    // console.log(dateiName)
    // console.log(selectedRegister)
    // console.log(selectedFile)
    // console.log(data)
    // console.log(selectedFile)
    // const headers={
    //     "Authorization": "Bearer "+accessToken,
    //     "Register": uploadRegister,
    //     "FileName": dateiName,
    //     "date":datumBis,
    //     "share":datumBis,
    //     "teilen":personenID,
    //     "Mandant": client, // this.props.client,
    //     "Program": "CWARCH",
    //     "Statement": "DATEI_IN_DMS_ABLEGEN"
    // }
    // apiRequest('POST', 'upload', data, headers, dataCb);    
  }
  const saveCB = (response) => {
    if (response.status === 200) {
      setShowModal(false)
      setIsLoading(false)
      showSuccessMessage(response.data.message)
    } else {
    }
}

  const register_auswahl = (register !== undefined) ? register.filter((obj) => obj.ord === selectedOrdner).map((dataObject) => {
    return (
      <MenuItem key={dataObject.key} value={dataObject.key}>
        {dataObject.bez}
      </MenuItem>
    );
  })
    :
    <MenuItem key={"null"} value={"Kein"}>{t("Keine Dateien gefunden")}</MenuItem>
    ;
  const ordner_auswahl = (ordner !== undefined) ? ordner.map((dataObject, count) => {
    return (
      <MenuItem color="primary" key={count} value={dataObject.key}>
        {dataObject.name}
      </MenuItem>
    );
  })
    :
    <MenuItem key={"null"} value={"Kein"}>{t("Keine Dateien gefunden")}</MenuItem>
    ;

  return (
    <div>
      <Typography align="center" variant="h4">{t("Datei ins DMS laden")}</Typography>
      <input
        multiple
        color="primary"
        type="file"
        id="file-upload"
        onChange={onChangeHandler}
        style={{ display: 'none' }}
      />
      <label htmlFor="file-upload" className="mr-2">
        <Button
          style={{ marginTop: "18px"}}
          variant="contained"
          component="span"
          color="primary"
          label={t("Dateiupload")}
        >{t("Datei auswählen")}
        </Button>
      </label>
      {selectedFile ?
        <>
          <Typography style={{ display: "" }}> {selectedFile.length} {selectedFile.length > 1 ? "Dateien" : "Datei"} ausgewählt</Typography>
          <TextField
            id="folder"
            label={t("Ordner")}
            select
            fullWidth
            value={selectedOrdner}
            onChange={(e) => setSelectedOrdner(e.target.value)}
            variant="outlined"
            style={{ marginTop: "10px" }}
          >
            {ordner_auswahl}
          </TextField>
          {selectedOrdner !== "" &&
            <TextField
              id="folder"
              label={t("Register")}
              select
              fullWidth
              value={selectedRegister}
              onChange={(e) => setSelectedRegister(e.target.value)}
              variant="outlined"
              style={{ marginTop: "10px" }}
            >
              {register_auswahl}
            </TextField>
          }
          {selectedRegister !== "" ?
          <>
            <TextField
              id="folder"
              label={t("Geben Sie einen Dateinamen mit")}
              fullWidth
              defaultValue={selectedFile[0].name.substr(0, selectedFile[0].name.indexOf("."))}
              onChange={(e) => setDateiName(e.target.value)}
              variant="outlined"
              style={{ marginTop: "10px" }}
            />
          
          {dateiName !== "" &&
            <DateTextField
              id="folder"
              label={t("Ablagedatum mitgeben")}
              fullWidth
              value={ablageDatum}
              onChange={(e) => setAblageDatum(e.target.value)}
              variant="outlined"
              style={{ marginTop: "10px" }}
            />
          }
          {dateiName !== "" &&
            <>
              <TextField
                id="folder"
                label={t("Hier können Sie weitere Wörter welche das Dokument beschreiben mitgeben.")}
                fullWidth
                value={keyWords}
                onChange={(e) => setKeyWords(e.target.value)}
                variant="outlined"
                style={{ marginTop: "10px" }}
              />
              <Button
                style={{ marginTop:"10px",justifyContent:"center"}}
                color="primary"
                align="center"
                fullWidth
                variant="contained"
                display="flex"
                onClick={() =>uploadDocument()}>
                {t("Datei hochladen")}
              </Button>
            </>
          }
        
        </>
        :
        <>
        </>}
        </>
        :
        <>
        </>}
    </div>
  );
}
export default UploadComponent
